import call from './index'

export const login = data => {
	return call(`admin/admin/login`, data)
}
